// src/lib/session/sessionExpired.ts
// Minimal pub/sub for a one-shot "session expired" notification.
// Prevents duplicate UI when many concurrent 401s arrive.

let triggered = false;
const listeners = new Set<() => void>();

export function notifySessionExpired(): void {
  if (triggered) return;
  triggered = true;
  // microtask to avoid re-entrancy with axios error handlers
  Promise.resolve().then(() => {
    listeners.forEach((fn) => {
      try { fn(); } catch {}
    });
  });
}

export function subscribeSessionExpired(fn: () => void): () => void {
  listeners.add(fn);
  return () => listeners.delete(fn);
}

export function wasSessionExpiredNotified(): boolean {
  return triggered;
}
